import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AssessmentWizard } from '../components/assessment/AssessmentWizard';
import SafeIcon from '../common/SafeIcon';

export const TakeAssessment = () => {
  const navigate = useNavigate();

  const handleComplete = (answers) => {
    console.log('Assessment complete:', answers);
    // Her ville vi normalt lagret til Supabase
    setTimeout(() => navigate('/dashboard/assessments'), 1500);
  };

  return (
    <div className="min-h-screen bg-slate-50 pb-20">
      <div className="bg-white border-b border-slate-200 mb-8">
        <div className="max-w-7xl mx-auto px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center text-white">
              <SafeIcon name="Clipboard" />
            </div>
            <h1 className="font-bold text-slate-800">Full Workplace Assessment</h1>
          </div>
          <button 
            onClick={() => navigate('/dashboard/assessments')}
            className="text-sm text-slate-500 hover:text-slate-800 transition-colors"
          >
            Avbryt og gå tilbake
          </button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-8">
        <AssessmentWizard onComplete={handleComplete} />
      </div>
    </div>
  );
};